import { useParams } from "react-router-dom";
import LessonPage from "./LessonPage";

const LessonWrapper = () => {
	const { lessonId } = useParams();
	return <LessonPage key={lessonId} />;
};

export default LessonWrapper;
